import React, { ReactNode, useEffect } from "react";

import CloseIcon from "@mui/icons-material/Close";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogProps,
	DialogTitle,
	Divider,
	Fab,
	List,
	ListItem,
} from "@mui/material";

type Props = {
	open: boolean;
	onClose: () => void;
	children: React.ReactNode;
	isFullScreen?: boolean;
	title?: string | ReactNode;
};

const StyledFullModal = (props: Props) => {
	const { open, onClose } = props;
	const [maxWidth, setMaxWidth] = React.useState<DialogProps["maxWidth"]>("xl");

	useEffect(() => {
		if (props.isFullScreen) {
			setMaxWidth("xl");
		} else {
			setMaxWidth("lg");
		}
	}, [props.isFullScreen]);

	const toggleMaxWidth = () => {
		setMaxWidth(maxWidth === "xl" ? "lg" : "xl");
	};

	return (
		<Dialog
			fullScreen={maxWidth === "xl" ? true : false}
			fullWidth={maxWidth === "xl" ? false : true}
			maxWidth={maxWidth}
			sx={{
				margin: "0 3rem",
				"& .MuiDialog-paper": {
					borderRadius: "0.5rem",
					overflowY: "visible",
					height: "100%",
					maxHeight: "100%",
				},
			}}
			open={open}
			onClose={onClose}
		>
			{props.title && (
				<>
					<DialogTitle sx={{ padding: "1rem" }}>{props.title}</DialogTitle>
					<Divider />
				</>
			)}
			<DialogContent sx={{ padding: 0 }}>{props.children}</DialogContent>

			<DialogActions
				sx={{
					position: "absolute",
					top: "-1rem",
					right: "-4.7rem",
					padding: "1rem",
				}}
			>
				<List sx={{ display: "flex", flexDirection: "column" }}>
					<ListItem>
						<Fab
							size="small"
							onClick={() => onClose()}
							data-tour="node-diagram-checklist-modal-close"
						>
							<CloseIcon fontSize="small" />
						</Fab>
					</ListItem>
					<ListItem>
						<Fab size="small" onClick={() => toggleMaxWidth()}>
							{maxWidth === "xl" ? (
								<CloseFullscreenIcon fontSize="small" />
							) : (
								<OpenInFullIcon fontSize="small" />
							)}
						</Fab>
					</ListItem>
				</List>
			</DialogActions>
		</Dialog>
	);
};

export default StyledFullModal;
